import { NavigateFunction } from "react-router-dom";
import { AppDispatch } from "../../../../store/store";
import { logActionEvent } from "../../../../analytics/analytics_utils";
import { LocalStorage } from "../../../../utils/Utils";
import { clearPrograms } from "../../../calender/data/redux/reducer/ProgramDetailReducer";
import { clearEvents } from "../../../calender/data/redux/reducer/eventReducer";
import { clearSelectedProgram } from "../../../recommendation/vedio-recommendation/data/redux/DropdownSLice";
import { clearJozunaSelectedProgram } from "../../../recommendation/vedio-recommendation/data/redux/JozunaDropdown";
import { LogOutResponse } from "../response/LogOut_Response";
import LogoutClient from "../api/LogoutClient";
import analytics_strings from "../../../../analytics/analytics_strings";
import Logger from "../../../../utils/Logger";
import Loader from "../../../../utils/Utils";
import { AxiosInstance } from "axios";
import HttpService from "../../../../service/HttpService";
import { useCamera } from "../../../assessment_question/components/CameraContext";

const logoutUser = async (
  dispatch: AppDispatch,
  navigate: NavigateFunction,
  candidate_id: string,
  api: HttpService,
  closeAssessmentCamera: () => void,
) => {
  //   const setAuthToken = () => {
  //     api.setAuthToken(window.localStorage.getItem("access_token"));
  //   };

  try {
    Loader.showLoading("Loading...");
    logActionEvent(analytics_strings.analytics_events.logoutButton, {
      candidate_id,
    });

    // setAuthToken();
    const res = await api.post<LogOutResponse>(LogoutClient.logoutURL); // ✅ Now valid

    if (res?.data?.error === null) {
      LocalStorage.deleteAllLocalData();
      dispatch(clearEvents());
      dispatch(clearPrograms());
      dispatch(clearSelectedProgram());
      dispatch(clearJozunaSelectedProgram());
      navigate("/", { replace: true });
      closeAssessmentCamera();
    }
  } catch (error) {
    Logger.info("logout error", error);
  } finally {
    Loader.dismissLoading();
  }
};
export default logoutUser;
